import React, {FC} from "react"

import {OuterContainer, ImageBorder, ImageContainer, StyledImage} from "./styled"

export const DEFAULT_SIZE = 150
export const DEFAULT_BORDER_SIZE = 10

interface Props {
  image: string,
  alt: string,
  size?: number,
  border?: number,
  alignLeft?: boolean,
  backgroundColor?: string
}

const Image: FC<Props> = ({image, alt, size, border, alignLeft, backgroundColor}) => {
  return (
    <ImageContainer size={size}>
      <OuterContainer size={size}>
        <ImageBorder size={size} border={border} alignLeft={alignLeft} backgroundColor={backgroundColor}>
          <StyledImage src={image} size={size - border} alt={alt} noBorderRadius={backgroundColor === "transparent"} />
        </ImageBorder>
      </OuterContainer>
    </ImageContainer>
  )
}

Image.defaultProps = {
  size: DEFAULT_SIZE,
  border: DEFAULT_BORDER_SIZE
}

export default Image
